export default __webpack_public_path__ + "static/media/04.20be07a5.jpg";